import classNames from './util'

const Button = (props) => <div
  id={props.id}
  className={classNames(!props.skipDefaultClass && 'widgets-Button', props.className)}
  onClick={props.onClick}>{props.children}
</div>

export default Button
